import React, { useEffect, useState } from "react";
import { isDefined } from "../helpers";

export default function Checkbox({
  label,
  name,
  onChange,
  storageKey,
  defaultValue,
  description,
  className,
}: {
  label: string;
  name: string;
  onChange: (key: string, value: any) => void;
  storageKey?: string;
  defaultValue?: boolean;
  description?: string;
  className?: string;
}) {
  const [value, setValue] = useState(
    isDefined(defaultValue) ? defaultValue : false
  );
  const useStorage = storageKey && typeof window.localStorage !== "undefined";

  useEffect(() => {
    if (useStorage) {
      const ls = localStorage.getItem(storageKey as string);
      const v = ls
        ? ls === "true"
        : isDefined(defaultValue)
        ? defaultValue
        : false;
      setValue(v);
      onChange(name, v);
    } else {
      onChange(name, value);
    }
  }, []);
  return (
    <div className={"rel " + (className || "")}>
      <label className="checkbox">
        {label}
        <input
          type="checkbox"
          checked={value}
          onChange={() => {
            if (useStorage) {
              localStorage.setItem(storageKey as string, String(!value));
            }
            setValue(!value);
            onChange(name, !value);
          }}
        />
        <span className="checkmark"></span>
      </label>
      {description && (
        <>
          <small className="op06 block mb1">{description}</small>
        </>
      )}
    </div>
  );
}
